export const SCOPING_QUESTIONNAIRE_TYPE = 1;
export const SECURITY_QUESTIONNAIRE_TYPE = 4;
export const SUPPLEMENTAL_QUESTIONNAIRE_TYPE = 5;

export const PORTAL_2_PORTALID = 2;
export const QA_APPROVED_QUESTIONNAIRE_TEMPLATE = 23;